export default __webpack_public_path__ + "static/m-01-5dfe3152de52f706736df3f42ee6b2e9.jpeg";